import documentApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleDocuments';

type ThisApi = ApiDefinition['/document-request-users/{id}/files/{fileId}/documents/{fileDocumentId}/move']['POST'];
type Input = ThisApi['params'] & ThisApi['body'];

const moveDocumentRequestUserFileDocument = async ({
  id,
  fileId,
  fileDocumentId,
  targetFileId,
}: Input): Promise<ThisApi['response']> => {
  const response = await documentApiClient.post<ThisApi['response']>(
    `/document-request-users/${id}/files/${fileId}/documents/${fileDocumentId}/move`,
    { targetFileId },
  );
  return response.data;
};

export default moveDocumentRequestUserFileDocument;
